<template>
  <div
    class="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8"
  >
    <div class="max-w-md w-full space-y-8">
      <div>
        <img
          class="mx-auto h-12 w-auto"
          src="@/assets/logo.svg"
          alt="Workflow"
        />
        <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Welcome to our platform
        </h2>
        <p class="mt-2 text-center text-sm text-gray-600">
          Please fill in all the fields to register
        </p>
      </div>
      <div class="mt-8 space-y-6">
                <div>
          <label for="email" class="block text-sm font-medium text-gray-700">
            First name
          </label>
          <div class="mt-1">
            <input
              id="email"
              name="email"
              type="text"
              required
              class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              v-model="firstname"
            />
          </div>
        </div>
                <div>
          <label for="email" class="block text-sm font-medium text-gray-700">
            Last name
          </label>
          <div class="mt-1">
            <input
              id="email"
              name="email"
              type="text"
              required
              class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              v-model="lastname"
            />
          </div>
        </div>
                <div>
          <label for="email" class="block text-sm font-medium text-gray-700">
            Phone number
          </label>
          <div class="mt-1">
            <input
              id="email"
              name="email"
              type="text"
              required
              class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              v-model="phone"
            />
          </div>
        </div>
        <div>
          <label for="email" class="block text-sm font-medium text-gray-700">
            Choose your password
          </label>
          <div class="mt-1">
            <input
              id="email"
              name="email"
              type="password"
              required
              class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              v-model="passwordA"
            />
          </div>
        </div>
        <div>
          <label for="email" class="block text-sm font-medium text-gray-700">
            Re enter your password
          </label>
          <div class="mt-1">
            <input
              id="email"
              name="email"
              type="password"
              required
              class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              v-model="passwordB"
            />
          </div>
        </div>
        <div>
          <button
            class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            @click="request()"
          >
            <span class="absolute left-0 inset-y-0 flex items-center pl-3">
              <!-- Heroicon name: solid/lock-closed -->
              <svg
                class="h-5 w-5 text-indigo-500 group-hover:text-indigo-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                  clip-rule="evenodd"
                />
              </svg>
            </span>
            Register account
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">


  export default {
    name: 'Login',
    data(){
      return{
        firstname: '',
        lastname: '',
        phone: '',
        passwordA:'',
        passwordB:'',
      };
    },
    components: {

    },
    computed:{
    },
    methods:{
      request(){
        this.$store.dispatch("user/inviteRegister", {
          firstname:this.firstname,
          lastname:this.lastname,
          phone:this.phone,
          password:this.passwordB,
          invitationToken: this.$route.params.token
        });
      },
    }
  };
</script>

<style>
</style>